import { useTranslation } from "react-i18next"

import { Search } from "@/components/icons"
import { Input } from "@/components/ui/input"

type ContextSidebarSearchProps = {
  value: string
  onChange: (value: string) => void
}

export function ContextSidebarSearch({ value, onChange }: ContextSidebarSearchProps) {
  const { t } = useTranslation("", { keyPrefix: "settingsmenu" })

  return (
    <div className="relative">
      <Search className="text-muted-foreground absolute top-2.5 left-2.5 h-4 w-4" />
      <Input
        className="h-9 pl-9"
        value={value}
        placeholder={t("context_sidebar_search_placeholder", {
          defaultValue: "Search files, references, and citation names…",
        })}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  )
}
